import useUserInfo from "../../../../Hooks/useUserInfo";
import Task from "../../../Task/Task";
import UfwImage from "../../../../../src/assets/ipl/Ufw-Pause.svg"


const IplInfo =(props)=>{
    const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();

    const goToThePage = (component, name) => {
        updateUserInfo((prev) => {
          return {
            ...prev,
            ...{
              currentComponent: component,
              currentComponentText: name,
              lastComponent: userDetails?.currentComponent,
              lastComponentText: userDetails?.currentComponentText,
              centerCount: userDetails?.centerCount + 1,
            },
          };
        });
      };
      const IsPromoClose = () => {
        props?.setOpenPopup(false); // hide popup
      };
      return(
        <>
       
      <div class="spinning-animation"></div>
      <div style={{pointerEvents:"fill"}}>
    <div style={{ position: "relative" }}>
     
        <div>
          <img
          onClick={() => {
            goToThePage(Task,"Task");
          }}
            // src="https://d1ccopf5cw1hft.cloudfront.net/s3data/ufw-pause.svg"
            src = {UfwImage}
            style={{
                pointerEvents: "fill",
              zIndex: "1",
              width: "100%",
              height: "100%",
              display: "block",
              borderRadius: "24px",
            }}
            alt="Background"
          />

        </div>
        <div style={{alignItems:"center",width:"100%",textAlign:"center"}}>
        <img
          onClick={IsPromoClose}
          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
          className="" style={{width:"30px"}}
        />
        </div>
     
    </div>
    
       
      
  </div>
        </>
    
  )
}
export default IplInfo;